exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".order-confirmation-page .bold-text {\n  font-size: 1.0em;\n  font-weight: bold; }\n\n.order-confirmation-page .normal-text {\n  font-size: 1.0em;\n  font-weight: normal; }\n\n.order-confirmation-page .order-item-summary {\n  padding-top: 2.5rem;\n  padding-bottom: 3.5rem; }\n\n.order-confirmation-page .button-finish {\n  background: #231f20;\n  margin-left: auto; }\n\n@media screen and (max-width: 480px) {\n  .order-confirmation-page .footer .button-finish {\n    width: 100%; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/pages/OrderConfirmationPage/OrderConfirmationPage.scss
// module id = 1644
// module chunks = 0